<script setup lang="ts">
import { RouterLink, RouterView } from 'vue-router';
</script>

<template>
    <main class="ktg-main-container">
        <h1 class="ktg-title-01 mb-2rem">{{ $t('admin') }}</h1>
        <nav class="mb-2rem">
            <ktg-tabs>
                <RouterLink :to="{ name: 'admin-users' }" custom v-slot="{ isActive, navigate }">
                    <ktg-tab :active="isActive || null" @activate="navigate">{{ $t('users') }}</ktg-tab>
                </RouterLink>
                <RouterLink :to="{ name: 'admin-stellen' }" custom v-slot="{ isActive, navigate }">
                    <ktg-tab :active="isActive || null" @activate="navigate">{{ $t('stellen') }}</ktg-tab>
                </RouterLink>
                <RouterLink :to="{ name: 'admin-connectivity' }" custom v-slot="{ isActive, navigate }">
                    <ktg-tab :active="isActive || null" @activate="navigate">{{ $t('connectivity') }}</ktg-tab>
                </RouterLink>
            </ktg-tabs>
        </nav>

        <RouterView></RouterView>
    </main>
</template>